<template>
  <el-card shadow="never" class="aui-card--fill">
    <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-select v-model="dataForm.userId" filterable clearable placeholder="账户名称">
            <el-option v-for="item in  fundList" :key="item.userId" :value="item.userId" :label="item.deptName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.serialNo"
            placeholder="交易流水"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :default-time="['00:00:00','23:59:59']"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.incomeAndExpensesType" filterable clearable placeholder="收支类型">
            <el-option v-for="item in  incomeTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.tradeType" filterable clearable placeholder="交易类型">
            <el-option v-for="item in  payTypeList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.chargesId" filterable clearable placeholder="费用名称">
            <el-option v-for="item in  feeTypeList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.childrenChargesId" filterable clearable placeholder="子费用名称">
            <el-option v-for="item in  feeTypeChildrenList" :key="item.id" :value="item.id" :label="item.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="dataForm.agreementCode"
            placeholder="借款编号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" plain @click="inquire()">{{ $t("query") }}</el-button>
        </el-form-item>
      </el-form>
      <div class="type">
        <!-- <div class="sum_amount">
          <div class="number">32,000.00</div>
          <div class="text">总额/元</div>
        </div>
        <div class="type_item">
          <div>开户费/年费</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{allowancetoTalMoney ? allowancetoTalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve6.svg" alt="">
          </div>
        </div> -->
        <div class="type_item">
          <div>通道费</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{allowancetoTalMoney ? allowancetoTalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve1.svg" alt="">
          </div>
        </div>
        <div class="type_item">
          <div>三方支付</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{paymentTotalMoney ? paymentTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve2.svg" alt="">
          </div>
        </div>
        <div class="type_item">
          <div>电子签章</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{esignTotalMoney ? esignTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 }) : 0}}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve3.svg" alt="">
          </div>
        </div>
        <div class="type_item">
          <div>公证</div>
          <div class="i_price"><span class="pri_dollar">￥</span>{{ notarizationTotalMoney ? notarizationTotalMoney.toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2}) : 0 }}</div>
          <div class="i_icon">
            <img src="../../../assets/img/subcurve4.svg" alt="">
          </div>
        </div>
      </div>
    <el-table
        v-loading="dataListLoading"
        :data="dataList"
        style="width: 100%"
        border
    >
      <el-table-column prop="userName" label="账户名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="tradingHour" label="交易时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="serialNo" label="交易流水" header-align="center" align="center"></el-table-column>
      <el-table-column prop="incomeExpenseType" label="收支类型" header-align="center" align="center"></el-table-column>
      <el-table-column prop="tradeType" label="交易类型" header-align="center" align="center"></el-table-column>
      <el-table-column prop="chargesName" label="费用名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="childrenChargesName" label="子费用名称" header-align="center" align="center"></el-table-column>
      <el-table-column prop="accrual" label="发生额" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.accrual != null">{{'￥'+ Number(scope.row.accrual).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="availableBalance" label="可用余额" header-align="center" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.availableBalance != null">{{'￥'+ Number(scope.row.availableBalance).toLocaleString('en-US',{ minimumFractionDigits: 2, maximumFractionDigits: 2 })}}</div>
        </template>
      </el-table-column>
      
      <el-table-column prop="agreementCode" label="借款编号" header-align="center" align="center"></el-table-column>
      <el-table-column prop="createTime" label="创建时间" header-align="center" align="center"></el-table-column>
      <el-table-column prop="remark" label="备注" header-align="center" align="center"></el-table-column>
    </el-table>
    <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="parseInt(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-card>
</template>
<script>
import mixinViewModule from '@/mixins/view-module'
export default {
  mixins: [mixinViewModule],
  
  data() {
    return {
      
      date:null,
      fundList:[],
      incomeTypeList:[],
      payTypeList:[],
      feeTypeList:[],
      feeTypeChildrenList:[],
      
      allowancetoTalMoney:'',
      paymentTotalMoney:'',
      esignTotalMoney:'',
      notarizationTotalMoney:'',
      mixinViewModuleOptions: {
        getDataListURL: `/system/capital_cost/pageList`,
        getDataListIsPage: true,
        multilist:true,
      },
    } 
  },
  watch: {
    $route: {
      handler(newVal, odlVal) {
        if (newVal.path === "/loan-expenditure") {
          this.getInfo()
          this.getDataList()
        } 
      },
      deep: true,
      immediate: true,
    },
  },
  created(){
    if(this.$route.query && this.$route.query.month){
      const today = new Date();
      const currentMonth = today.getMonth() + 1;
      const currentYear = today.getFullYear();
      const startDate = new Date(currentYear, currentMonth - 1, 1);
      const endDate = new Date(currentYear, currentMonth, 0);
      this.date = [startDate, endDate]
      this.dataForm = {
        ...this.dataForm,
        startTime:this.formatDate(startDate),
        endTime:this.formatDate(endDate.setHours(23, 59, 59, 999)),
        chargesId:'1'
      }
      this.getDataList()
      this.getInfo()
    }else{
      this.getDataList()
      this.getInfo()
    }
    this.$http.get('/sys/user/queryUserIdList').then(res=>{
        this.fundList = res.data.data
    })
    this.$http.get(`/sys/dict/data/list?dataType=income_expenses`).then(r=>{
      this.incomeTypeList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []    
    })
    this.$http.get(`/sys/dict/data/list?dataType=pay_type`).then(r=>{
      this.payTypeList = r.data.data ? r.data.data.map(item => ({value:item.dictLabel,label:item.dictLabel})) : []    
    })
    this.$http.get('/system/serviceFeesType/list/1').then(res=>{
      this.feeTypeList = res.data.data || []
    })
    this.$http.get(`/system/serviceFeesType/list/0`).then(res=>{
      this.feeTypeChildrenList = res.data.data || []
    })

    this.$http.get('sys/user/info').then(res=>{
      if(res.data.code != 0){
        return this.$message.error(res.data.msg)
      }
    })


  },
  methods:{
    getInfo(){
      this.$http.get('system/capital_cost/selectCapitalCostDataCounts',{
        params:{
          ...this.dataForm
        }
      }).then(res=>{
        if(res.data.code != 0){
          return this.$message.error(res.data.msg)
        }
        this.allowancetoTalMoney = res.data.data.allowancetoTalMoney
        this.paymentTotalMoney = res.data.data.paymentTotalMoney
        this.esignTotalMoney = res.data.data.esignTotalMoney
        this.notarizationTotalMoney = res.data.data.notarizationTotalMoney
        
      })
    },
    formatDate(dateString) {
      const dateObj = new Date(dateString);
      const year = dateObj.getFullYear();
      const month = this.addLeadingZero(dateObj.getMonth() + 1);
      const day = this.addLeadingZero(dateObj.getDate());
      const hours = this.addLeadingZero(dateObj.getHours());
      const minutes = this.addLeadingZero(dateObj.getMinutes());
      const seconds = this.addLeadingZero(dateObj.getSeconds());
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
    addLeadingZero(num) {
      return num < 10 ? `0${num}` : num;
    },
    getTimes() {
        if (this.date != null) {
          this.dataForm.startTime = this.date[0]
          this.dataForm.endTime = this.date[1]
        }else{
          this.dataForm.startTime =''
          this.dataForm.endTime = ''
        }
    },
    inquire(){
      this.getDataList('dept')
      this.getInfo()
    },

  }
}
</script>
<style scoped lang="scss">
  .type{
    display: flex;
    justify-content: space-between;
    padding: 30px 0;
    .sum_amount{
      background-color: #2cb3a3;
      color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      padding: 0 20px;
      .number{
        font-size: 36px;
        margin-bottom: 20px;
      }
      .text{
        font-size: 17px;
      }
    }
    .type_item{
      margin-top: 30px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: bold;
      .i_price{
        font-size: 30px;
        margin-top: 20px;
      }
      .i_icon{
        width: 120px;
        img{
          width: 100%;
        }
      }
    }
  }
  .pri_dollar{
    font-size: 22px;
    position: relative;
    bottom: 3px;
    font-weight: normal;
  }
</style>